/* src/views/OperatorsView.js */
import { Users, CalendarClock, Plus, Edit, Trash2, X, AlertCircle, Camera, Check } from 'lucide-vue-next'
import { ref, reactive, onMounted } from 'vue'
import { OperatorService } from '@/services/OperatorService'
import Swal from 'sweetalert2'

const weekDaysNames = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']

export default {
  name: 'OperatorsView',
  components: { Users, CalendarClock, Plus, Edit, Trash2, X, AlertCircle, Camera, Check },

  setup() {
    const activeTab = ref('operators')
    const availableSkills = ref([])
    const currentEditingSchedOp = ref(null)
    const editingShifts = ref([])
    const isOpDrawerOpen = ref(false)
    const isSchedDrawerOpen = ref(false)
    const operators = ref([])
    const opFormError = ref('')
    const schedules = ref([])
    const selectedSkillToAdd = ref('')
    
    const opForm = reactive({
      id: 0, name: '', qualifica: '', bio: '', skills: [], isActive: true, avatar: ''
    })

    const fetchSkills = async () => {
      try { availableSkills.value = await OperatorService.fetchSkills() }
      catch (error) { console.error("Errore fetchSkills:", error) }
    }

    const fetchOperators = async () => {
      try {
        operators.value = await OperatorService.getAll()
        const realSchedules = await OperatorService.getSchedules()
        schedules.value = operators.value.map(op => {
          const opSched = realSchedules.filter(s => s.operator_id === op.id)
          return {
            operatorId: op.id,
            shifts: weekDaysNames.map((day, index) => {
              const found = opSched.find(s => s.day_of_week === index)
              return {
                day: day,
                isWorking: !!found, 
                start: found ? found.start_time.substring(0, 5) : '09:00',
                end: found ? found.end_time.substring(0, 5) : '18:00'
              }
            })
          }
        })
      } catch (error) { console.error("Errore nel caricamento:", error) }
    }

    onMounted(async () => { await Promise.all([fetchSkills(), fetchOperators()]) })

    const openOpCreate = () => {
      Object.assign(opForm, { id: 0, name: '', qualifica: '', bio: '', skills: [], isActive: true, avatar: '' })
      isOpDrawerOpen.value = true
    }

    // --- CORREZIONE: ESPANSIONE ID IN OGGETTI ---
    const openOpEdit = (op) => {
      const opCopy = JSON.parse(JSON.stringify(op));
      // Trasformiamo gli ID numerici in oggetti {id, name}
      opCopy.skills = opCopy.skills.map(skillId => {
        const found = availableSkills.value.find(s => s.id === skillId);
        return found ? found : { id: skillId, name: 'Competenza non trovata' };
      });
      Object.assign(opForm, opCopy);
      isOpDrawerOpen.value = true
    }

    // --- CORREZIONE: ADD SKILL ACCETTA OGGETTO ---
    const addSkill = () => {
      if (selectedSkillToAdd.value && !opForm.skills.find(s => s.id === selectedSkillToAdd.value.id)) {
        opForm.skills.push(selectedSkillToAdd.value)
        selectedSkillToAdd.value = ''
      }
    }

    const removeSkill = (skill) => {
      opForm.skills = opForm.skills.filter(s => s.id !== skill.id)
    }

    const saveOperator = async () => {
      try {
        opFormError.value = ''
        // Il Service si occupa di estrarre gli ID tramite mapToApi
        if (opForm.id === 0) await OperatorService.create(opForm)
        else await OperatorService.update(opForm.id, opForm)
        
        await fetchOperators()
        isOpDrawerOpen.value = false
        Swal.fire('Successo', 'Operatore salvato', 'success')
      } catch (error) { opFormError.value = 'Errore: ' + error.message }
    }

    const deleteOperator = async (id) => {
      const confirm = await Swal.fire({ title: 'Sei sicuro?', icon: 'warning', showCancelButton: true })
      if (confirm.isConfirmed) {
        await OperatorService.delete(id)
        await fetchOperators()
      }
    }

    const openSchedEdit = (opId) => {
      const op = operators.value.find(o => o.id === opId)
      const sched = schedules.value.find(s => s.operatorId === opId)
      if (op && sched) {
        currentEditingSchedOp.value = op
        editingShifts.value = JSON.parse(JSON.stringify(sched.shifts))
        isSchedDrawerOpen.value = true
      }
    }

    const saveSchedule = async () => {
      try {
        await OperatorService.updateSchedule(currentEditingSchedOp.value.id, editingShifts.value)
        await fetchOperators()
        Swal.fire('Successo', 'Turni aggiornati', 'success')
        isSchedDrawerOpen.value = false
      } catch (error) { Swal.fire('Errore', 'Problema nel salvataggio', 'error') }
    }

    return {
      activeTab, operators, schedules, availableSkills, weekDaysNames,
      isOpDrawerOpen, isSchedDrawerOpen, opForm, opFormError, selectedSkillToAdd,
      openOpCreate, openOpEdit, addSkill, removeSkill, saveOperator, deleteOperator,
      openSchedEdit, saveSchedule, closeOpDrawer: () => isOpDrawerOpen.value = false, 
      closeSchedDrawer: () => isSchedDrawerOpen.value = false,
      editingShifts, currentEditingSchedOp, 
      getSkillName: (id) => availableSkills.value.find(s => s.id === id)?.name || 'Sconosciuta',
      getOperator: (id) => operators.value.find(o => o.id === id)
    }
  }
}